export class IncType {
    IncTypeDesc;
    IncSubType;
    IR56BRow;
    MPF;
    constructor() {
        this.IncTypeDesc = "";
        this.IncSubType = "";
        this.IR56BRow = "";
        this.MPF = false;
    }
}



// WEBPACK FOOTER //
// ./src/model/IncType.js